import Vue from 'vue';
import Buefy from 'buefy';
import VueFbCustomerChat from 'vue-fb-customer-chat';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import ImageKit from '@/plugins/imagekit';
import Sentry from '@/plugins/sentry';
import VueI18n from 'vue-i18n';
import { localize } from 'vee-validate';
import VueCookies from 'vue-cookies';
import lang from '@/lang';

import '@/rules/setup';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.use(VueCookies);
Vue.use(VueI18n);
Vue.use(Sentry);
Vue.use(ImageKit);
Vue.use(Buefy);

const locale = Vue.$cookies.get('locale') || 'en_US';

Vue.use(VueFbCustomerChat, {
  locale,
  page_id: process.env.VUE_APP_FACEBOOK_PAGE_ID,
});
Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'th_TH',
  messages: lang,
});

if (locale === 'th_TH') {
  localize('th');
} else {
  localize('en');
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

Vue.$cookies.config('30d');
